import { getToken } from './config/AdalConfig';
//import Api from './Api'

export default (url: string, options?: any): Promise<Response> => {
  const authHeader = {
    Authorization: `Bearer ${getToken()}`,
    'Content-Type': 'application/json'
  };
  options = options || {};
  options.headers = authHeader;
  return fetch(url, options);
};
